webpackJsonp([51558153065178],{

/***/ 809:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"h4":"src-styles----faq-module---h4---2geNX","faq_list":"src-styles----faq-module---faq_list---2rV1v","faq_item":"src-styles----faq-module---faq_item---3Mt6d","faq_item_inner":"src-styles----faq-module---faq_item_inner---3mGFq"};

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Jumbotron = __webpack_require__(17);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _CallToAction = __webpack_require__(38);
	
	var _CallToAction2 = _interopRequireDefault(_CallToAction);
	
	var _PageWrapper = __webpack_require__(21);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactScroll = __webpack_require__(48);
	
	var _faqModule = __webpack_require__(809);
	
	var _faqModule2 = _interopRequireDefault(_faqModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var FAQ = function (_React$Component) {
		_inherits(FAQ, _React$Component);
	
		function FAQ(props) {
			_classCallCheck(this, FAQ);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				currentCat: "latest",
	
				loadMore: true
			};
			return _this;
		}
	
		FAQ.prototype.componentDidMount = function componentDidMount() {
			var hashCategory = this.props.location.hash.slice(1);
			// alert(hashCategory);
			// scroller.scrollTo(hashCategory);
	
			_reactScroll.scroller.scrollTo(hashCategory, {
				duration: 500,
				delay: 100,
				smooth: true,
				offset: -100 // Scrolls to element + 50 pixels down the page
			});
		};
	
		FAQ.prototype.render = function render() {
			var _props = this.props,
			    transition = _props.transition,
			    data = _props.data;
	
			var faqArray = data.allContentfulFaq.edges;
			var cta = data.allContentfulCallToAction.edges[0].node;
			var pageSettings = data.contentfulFaqPage;
	
			var items = faqArray.map(function (question, i) {
				function createMarkup() {
					return {
						__html: question.node.answer.childMarkdownRemark.html
					};
				}
	
				return _react2.default.createElement(
					_reactScroll.Element,
					{
						key: "question-" + (i + 1),
						name: question.node.slug,
						className: "element"
					},
					_react2.default.createElement(
						"div",
						{ className: "row " + _faqModule2.default.faq_item },
						_react2.default.createElement(
							"div",
							{
								className: "col-12 col-lg-10 " + _faqModule2.default.faq_item_inner
							},
							_react2.default.createElement(
								"b",
								{ className: _faqModule2.default.h4 },
								question.node.question
							),
							_react2.default.createElement("div", { dangerouslySetInnerHTML: createMarkup() })
						)
					)
				);
			});
			return _react2.default.createElement(
				_PageWrapper2.default,
				{
					locale: pageSettings.node_locale,
					location: this.props.location,
					data: data.layout.edges[0].node
				},
				_react2.default.createElement(
					"main",
					{ role: "main", style: transition && transition.style },
					_react2.default.createElement(_reactHelmet2.default, { title: pageSettings.pageTitle }),
					_react2.default.createElement(
						_Jumbotron2.default,
						{
							type: "jumbotron_b",
							bottomLine: true,
							className: "mb-0",
							textAlign: "text-center",
							contentAlign: "justify-content-md-center"
						},
						_react2.default.createElement(
							"h1",
							null,
							pageSettings.pageTitle
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "container " + _faqModule2.default.faq_list },
						items
					),
					_react2.default.createElement(
						"div",
						{ className: "grey_bg py-4" },
						_react2.default.createElement(_CallToAction2.default, {
							className: "my-5",
							text: cta.content.childMarkdownRemark.html,
							buttonLabel: cta.buttonLabel,
							destination: "/" + pageSettings.node_locale + cta.linkTo,
							arrow: true
						})
					)
				)
			);
		};
	
		return FAQ;
	}(_react2.default.Component);
	
	exports.default = FAQ;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-faq-template-js-92cac86a0f6b27a27576.js